/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_2dc57bef"]'><div><cube-button @_click="showPicker">StartDate - 1EndDate</cube-button><cube-segment-picker ref="__mpx_ref_picker__" title="选择器" :list="(list)" :cancelTxt="(cancelTxt)" :confirmTxt="(confirmTxt)" @change='(e)=>__invoke(e, [["change"]])' @cancel='(e)=>__invoke(e, [["cancel"]])' @select='(e)=>__invoke(e, [["select"]])' @valueChange='(e)=>__invoke(e, [["valueChange"]])'></cube-segment-picker></div></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_2dc57bef"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_2dc57bef"}
  /** script content **/
  require("./segment-date-picker.mpx.js?isComponent&outputPath=components%2Fsegment-date-picker2dc57bef%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./segment-date-picker.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fsegment-date-picker2dc57bef%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_2dc57bef"],
    ctorType: "component",
    outputPath: "components/segment-date-picker2dc57bef/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-segment-picker':getComponent(require("../../../packages/mpx-cube-ui/src/components/segment-picker/index.mpx?isComponent&outputPath=components%2Findex2e097122%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>